import { lazy } from 'react';
import { withLoader } from '../helpers/withLoader';
const Signup = withLoader(lazy(() => import('./SignupPage')));
const Login = withLoader(lazy(() => import('./Login')));
const ResetPassword = withLoader(lazy(() => import('./ResetPassword')));
const Verify = withLoader(lazy(() => import('./Verify')));
const ConnectedCarriersPage = withLoader(lazy(() => import('./ConnectedCarriersPage')));
const AnalyticsPage = withLoader(lazy(() => import('./AnalyticsPage')));
const AutomationPage = withLoader(lazy(() => import('./AutomationPage')));
const Transports = withLoader(lazy(() => import('./Providers/TransportsProvider')));
const Impersonate = withLoader(lazy(() => import('./Login/Impersonate')));
const ExportResults = withLoader(lazy(() => import('./ExportResults')));
const MyAddresses = withLoader(lazy(() => import('./MyAddresses')));
export { AnalyticsPage, AutomationPage, ConnectedCarriersPage, ExportResults, Impersonate, Login, MyAddresses, ResetPassword, Signup, Transports, Verify, };
